<template>
  <a-button
    :href="link"
    :open-in-new-tab="false"
    class="become-an-author become-an-author-btn"
  >
    Become an author
  </a-button>
</template>

<script>
import { BUTTON_STYLE } from 'shared/AButton'
import { ROUTE_NAME } from 'enums/routes'

export default {
  name: 'BecomeAnAuthorButton',
  data() {
    return {
      BUTTON_STYLE,
      link: {
        name: ROUTE_NAME.BECOME_AN_AUTHOR
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.become-an-author.become-an-author-btn {
  width: 295px;

  @include mobile {
    width: 100%;
  }
}
</style>
